export default "__VITE_ASSET__Z$gOQVio__"